<div class="message d-flex p-2">
    @if(!message.isSystemMessage) {
    <img [src]="'https://static.h5arena.com/images/avatars/' + getUserPortrait(message.fromUser.portraitId)()"
        alt="avatar" class="rounded-circle align-self-start me-2 cursor-pointer" (dblclick)="onUserDblClick()">
    <div>
        <div class="d-flex align-items-baseline">
            <span class="fw-bold me-2 d-inline-flex align-items-center gap-1 cursor-pointer"
                (dblclick)="onUserDblClick()"
                [style.color]="message.fromUser.userNameColor ? message.fromUser.userNameColor : 'rgb(108, 117, 125)'">
                <span>{{ message.fromUser.userName }}</span>
                @if(isParentLobbyOwner()) {
                <i class="fas fa-feather-alt text-white" title="Lobby Owner"></i>
                }
                @if(isModerator()) {
                <img src="/images/moderator_icon.png" class="moderator-icon" width="14" height="14" alt="Moderator"
                    title="Room Moderator">
                }
            </span>
            <small class="text-secondary">{{ message.timestamp | date: 'short' }}</small>
        </div>
        @if(hasAttachment()) {
        <div class="mt-2 attachment-container">
            <div class="small text-secondary mb-1">{{ message.attachment.title }}</div>
            <img [src]="message.attachment.url" class="img-fluid rounded message-image shadow-sm"
                style="min-width: 128px; max-width: 300px; height: auto;" [alt]="message.attachment.title"
                data-bs-toggle="modal" [attr.data-bs-target]="'#lightbox-' + uniqueId">
        </div>
        } @else if(isImage()) {
        <div class="mt-2">
            <img [src]="message.text" class="img-fluid rounded message-image shadow-sm"
                style="max-width: 300px; max-height: 300px;" alt="Sent Image" data-bs-toggle="modal"
                [attr.data-bs-target]="'#lightbox-' + uniqueId">
        </div>
        } @else {
        <p class="mb-0" [className]="message.classes" [style.color]="message.color">{{ message.text }}</p>
        }

        @if(message.linkPreview) {
        <div class="mt-2 link-preview rounded overflow-hidden bg-black-50 cursor-pointer" style="max-width: 400px;"
            data-bs-toggle="modal" data-bs-target="#externalLinkModal" (click)="openLink(message.linkPreview.url)">
            @if(message.linkPreview.image && message.linkPreview.image.length > 0) {
            <img [src]="message.linkPreview.image[0]" class="img-fluid"
                style="max-height: 200px; width: 100%; object-fit: cover;" alt="Preview Image" #previewImg
                (error)="previewImg.src = 'https://picsum.photos/seed/linkpreview/400/200?grayscale&blur=2'">
            }
            <div class="p-2">
                <div class="fw-bold text-white">{{ message.linkPreview.title }}</div>
                <div class="text-muted mb-1">{{ message.linkPreview.description }}</div>
                <div class="text-white text-truncate d-block text-decoration-none">
                    <i class="bi bi-link-45deg"></i> {{ message.linkPreview.url }}
                </div>
            </div>
        </div>
        }
    </div>
    }@else {
    <p class="mb-0 fw-semibold text-warning">{{ message.text}}</p>
    }
</div>

@if(hasAttachment() || isImage()) {
<div class="modal fade" [id]="'lightbox-' + uniqueId" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content bg-transparent border-0 shadow-none">
            <div class="modal-body text-center p-0 position-relative">
                <button type="button" class="btn-close btn-close-white position-absolute top-0 end-0 m-3"
                    data-bs-dismiss="modal" aria-label="Close" style="z-index: 1100;"></button>
                <img [src]="lightboxSrc" class="img-fluid rounded shadow-lg"
                    style="max-height: 85vh; max-width: 100%; object-fit: contain; border: 1px solid rgba(255,255,255,0.1);">
            </div>
        </div>
    </div>
</div>
}